import { callPexels, PexelsImage, PexelsRequest } from "./pexels";
import { callUnsplash, UnsplashImage, UnsplashRequest } from "./unsplash";

export function pexelsImageToUnsplashImageFormat(
  image: PexelsImage
): UnsplashImage {
  return {
    id: image.id.toString(),
    description: null,
    alt_description: image.alt || null,
    urls: {
      raw: image.src.original,
      full: image.src.large2x,
      regular: image.src.large,
      small: image.src.medium,
      thumb: image.src.small
    },
    user: {
      name: image.photographer,
      username: image.photographer_url
    },
    width: image.width,
    height: image.height
  };
}

const provider: "pexels" | "unsplash" = "pexels";

export function callImageService(request: PexelsRequest | UnsplashRequest) {
  if (provider === "pexels") {
    return callPexels(request);
  } else {
    return callUnsplash(request);
  }
}
